import { getClient } from './Cognito';

export const rememberDevice = function(accessToken, deviceKey) {
  return new Promise(function(resolve, reject) {
    getClient().request(
      'UpdateDeviceStatus',
      {
        AccessToken: accessToken,
        DeviceKey: deviceKey,
        DeviceRememberedStatus: 'remembered',
      },
      err => {
        if (err) {
          reject(err);
        }
        resolve();
      }
    );
  });
};
